<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->

<template>
<span v-if="image">
  <template v-if="image.blindedName">
    <span class="blind-indication">[{{this.$t('blinded-name-indication')}}]</span>
    <!-- {{image.blindedName}} -->
    {{ $t('anonymized') }}
    <template v-if="image.id && showBothNames">
      <br>
      <span class="true-name">
        {{image.id || image.labelText}} <!-- backend will return this prop iff user is allowed to view it (admin or project manager) -->
      </span>
    </template>
  </template>
  <template v-else>
    <div :class="['image-text', trueName() ? 'normal' : 'italic']" :title="displayName()" >
      {{ displayName() }}
    </div>
  </template>
</span>
</template>

<script>
export default {
  name: 'image-name',
  props: {
    image: Object,
    showBothNames: {type: Boolean, default: false}
  },
  methods: {
    displayName() {
      const hasLabelText = this.image.labelText != null && this.image.labelText !== '';
      if (hasLabelText || (this.image.originalFilename !== this.image.instanceFilename)) {
        if (this.image.originalFilename !== this.image.instanceFilename) {
          return this.image.instanceFilename;
        }
        else {
          return this.image.labelText;
        }
      }
      else {
        return this.image.originalFilename;
      }
    },
    trueName() {
      const hasLabelText = this.image.labelText != null && this.image.labelText !== '';
      const isNormal = hasLabelText || (this.image.originalFilename !== this.image.instanceFilename);
      if (isNormal) {
        return true;
      }
      else {
        return false;
      }
    }
  },
};
</script>

<style scoped>
.blind-indication {
  font-size: 0.9em;
  text-transform: uppercase;

  text-decoration: none;
}

.true-name {
  /* margin-top: 0.2em; */
  font-size: 0.9em;
  color: #888;
  
  text-decoration: none;
}


.image-text {
  max-height: 2.4rem; /* 최대 두 줄 높이 */
  width: 100%;

  /* 줄바꿈 */
  white-space: normal;
  word-break: break-all;
  
  /* 말줄임표 */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.image-text.normal {
  font-style: normal;
}

.image-text.italic {
  font-style: italic;
}
</style>
